<h2 mat-dialog-title>{{ 'common.labels.validationLogs' | transloco }}</h2>
<mat-dialog-content>
  @if (validationLogs.length > 0) {
    <table mat-table [dataSource]="validationLogs" multiTemplateDataRows class="mat-elevation-z2">
      <!-- Severity -->
      <ng-container matColumnDef="validationLogTypeID">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.validationType' | transloco }} </th>
        <td mat-cell *matCellDef="let validationLog"> {{ validationLog.validationLogTypeID | enumLabel:'validationLogType' }} </td>
      </ng-container>
      <!-- Messsage -->
      <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.messsage' | transloco }} </th>
        <td mat-cell *matCellDef="let validationLog"> {{validationLog.message}} </td>
      </ng-container>
      <!-- path -->
      <ng-container matColumnDef="path">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.path' | transloco }} </th>
        <td mat-cell *matCellDef="let validationLog"> {{validationLog.path}} </td>
      </ng-container>
      <!-- Messsage -->
      <ng-container matColumnDef="detailedMessage">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.detailedMessage' | transloco }} </th>
        <td mat-cell *matCellDef="let validationLog"> {{validationLog.detailedMessage}} </td>
      </ng-container>
      <!-- Username -->
      <ng-container matColumnDef="username">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.username' | transloco }} </th>
        <td mat-cell *matCellDef="let validationLog"> {{validationLog.username}} </td>
      </ng-container>
      <!-- Added -->
      <ng-container matColumnDef="added">
        <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.added' | transloco }} </th>
        <td mat-cell *matCellDef="let validationLog"> {{validationLog.added | localizedDate:'yyyy-MM-dd HH:mm:ss'}}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;">
      </tr>
    </table>
  }
  <lib-placeholder iconName="warning" iconClass="icon-info"
    [message]="'orders.noValidationsAccepted' | transloco"
  [condition]="validationLogs.length === 0"></lib-placeholder>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="true">{{ 'common.buttons.close' | transloco }}</button>
</mat-dialog-actions>